import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as NetworkLoggerActions from './network-logger.actions';
import { map, withLatestFrom } from 'rxjs/operators';
import * as AuthActions from 'store/auth-store/auth.actions';
import * as fromNetworkLogger from './network-logger.reducer';
import { Store, select } from '@ngrx/store';
import dayjs from 'dayjs';

@Injectable()
export class NetworkLoggerEffects {
  constructor(private actions$: Actions, private store: Store<fromNetworkLogger.State>) {}

  /**
   * removes log-entries older than 5 days
   */
  cleanUpNetworkActivityLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.signOutSuccess),
      withLatestFrom(this.store.pipe(select(fromNetworkLogger.selectAll))),
      map(([, entries]) => {
        const ids = entries
          .filter((entry) => dayjs(entry.requestTimestamp).isBefore(dayjs().subtract(5, 'day')))
          .map((entry) => entry.id);

        return NetworkLoggerActions.cleanUpNetworkActivityLogs({ ids });
      })
    )
  );
}
